import styled from '@emotion/styled';
import { Button, type ButtonProps } from '@mui/material';
import PerspectivesIcon from '@/components/PerspectivesIcon';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import useIsPortfolioReadonly from '../../useIsPortfolioReadonly';

type ManagePerspectivesButtonProps = Omit<
  ButtonProps,
  'startIcon' | 'loadingPosition' | 'loading' | 'children'
> & {
  loading: boolean;
  children?: React.ReactNode;
};

const StyledButton = styled(Button)({
  marginBottom: 8,
  height: 32,
});

const ManagePerspectivesButton = ({
  loading,
  children,
  ...props
}: ManagePerspectivesButtonProps) => {
  const portfolioIsReadonly = useIsPortfolioReadonly();

  return (
    <StyledButton
      startIcon={<PerspectivesIcon size={18} />}
      loadingPosition="start"
      loading={loading}
      {...props}
    >
      {children ?? (
        <FormattedMessage
          id={`perspectives.attachment.manage_attachment_button${portfolioIsReadonly ? '.view_mode' : ''}`}
        />
      )}
    </StyledButton>
  );
};

export default ManagePerspectivesButton;
